import createDocument from "../../../utils/createDocument";
import createDocumentData from "../../../utils/createDocumentData";

import { ProductionTodo } from "../types/ProductionTodo";

export default function createProductionTodo(firebase, { production, ...data }) {
	const todo = ProductionTodo.parse(createDocumentData(firebase, `productions/${production.id}/todos`, data));

	return createDocument(todo);
}
